import { constants } from "../../../constants";

export default class GameAutoplayEnd {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    ENDOR_handler(data) {
        if (data.state === true) {
            this.gb.emitters.emit.web.gameAutoplayStart(data)
        }else {
            this.gb.emitters.emit.web.gameAutoplayEnd(data)
        }
    }
    _default(data) {
        this.gb.emitters.emit.web.gameAutoplayEnd(data);
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.SPIN:
                event["auto_stop"] = this._default;
                break;
            case constants.ENDOR:
                event["autoplaySwitched"] = this.ENDOR_handler;
                break;
            case constants.EDIG:
                event["autoPlayStopped"] = this._default;
                break;
            case constants.T4B:
                event["game.animation.ended"] = this._default;
                break;
            case constants.EYE:
                event["autoplayEnded"] = this._default;
                break;
            case constants.HNR:
                event["autoPlayEnded"] = this._default;
                break;
            case constants.BSFT:
                event["exi_onAutoplayFinalized"] = this._default;
                break;
            default:
                event["autoplayEnd"] = this._default;
        }

        return event;
    }
}
